import { Component, OnInit } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';
import * as g from 'src/app/globals';
import * as accounting from 'accounting';

@Component({
  selector: 'app-input-price-lines',
  templateUrl: './input-price-lines.component.html',
  styleUrls: ['./input-price-lines.component.less'],
})
export class InputPriceLinesComponent extends Field implements OnInit {
  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }

  addCurrencyBefore = !g.companyConfiguration.CurrencyOnRight;

  formatterPrice(value: number): string {
    if (value === null || isNaN(value)) {
      return '';
    }
    if (this.currencyField !== undefined) {
      console.log(this.currencyField.Value);
    }

    return accounting.formatNumber(
      value,
      g.companyConfiguration.PriceDecimal,
      g.companyConfiguration.ThousandSep,
      g.companyConfiguration.DecimalSep
    );
  }
}
